<template>
  <v-container
    v-shortkey.once="['esc']"
    fluid
    tag="section"
    @shortkey="escape"
  >
    <validation-observer
      ref="form"
      v-slot="{ passes }"
    >
      <v-form
        @submit.prevent="passes(save)"
      >
        <v-row justify="center">
          <v-col
            cols="12"
            md="12"
          >
            <material-card
              class="edit-form"
              color="primary"
              :icon="icon"
            >
              <template #title>
                {{ page_title }}
              </template>

              <template #title2>
                <v-btn
                  v-show="!newItem"
                  v-shortkey.once="['f8']"
                  color="delete"
                  dark
                  min-width="90"
                  tabindex="-1"
                  class="mr-3"
                  @click="remove"
                  @shortkey="remove"
                >
                  {{ $t('delete') }}
                </v-btn>
                <v-btn
                  color="cancel"
                  min-width="90"
                  class="mr-3"
                  @click="escape"
                >
                  {{ $t('cancel') }}
                </v-btn>
                <v-btn
                  v-shortkey.once="['f10']"
                  color="save"
                  dark
                  min-width="90"
                  type="submit"
                  @shortkey="passes(save)"
                >
                  {{ $t('save') }}
                </v-btn>
              </template>

              <v-container class="py-0">
                <!-- Editform -->
                <slot name="editform" />
              </v-container>
            </material-card>
          </v-col>
        </v-row>
      </v-form>
    </validation-observer>
  </v-container>
</template>

<script>
  export default {
    name: 'CumulusEditFormTablet',
    props: {
      icon: {
        type: String,
        default: '$edit',
      },
      title: {
        type: String,
        default: 'datas',
      },
      newItem: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      page_title () { return this.$t(this.newItem ? 'insert' : 'edit', { type: this.$t(this.title) }) },
    },
    methods: {
      save () {
        this.$emit('save')
      },
      remove () {
        this.$emit('remove')
      },
      escape () {
        this.$emit('escape')
      },
      setErrors (e) {
        this.$refs.form.setErrors(e)
        // this.$refs.form.setErrors(e.response.data.errors)
      },
    },
    beforeRouteEnter (to, from, next) {
      console.log('beforeRouteEnter in component')
    },
  }
</script>

<style lang="sass">
  .edit-form
    overscroll-behavior: none
</style>
